$(document).on('ajax:success', '[data-trackable]', function (e) {
  const data = e.detail[0]
  var $form = $(this)
  $form.find('[data-invalid="true"]').removeAttr('data-invalid')
  if (data.success) {
    $form.find('input,textarea').val('').change()
  } else {
    Object.keys(data.errors || {}).forEach(function (attribute) {
      $form.find("[name$='[" + attribute + "]']").attr('data-invalid', true)
    })
  }
})
